import { ptBR } from "@material-ui/core/locale";
import { getThemePaletteMode } from "@material-ui/data-grid";
import {
    makeStyles,
    createMuiTheme,
    darken,
    lighten,
} from "@material-ui/core/styles";


const defaultTheme = createMuiTheme();

export const useStyles = makeStyles(
    (theme) => {
        const getBackgroundColor = (color) =>
            getThemePaletteMode(theme.palette) === "dark"
                ? darken(color, 0.6)
                : lighten(color, 0.6);

        const getHoverBackgroundColor = (color) =>
            getThemePaletteMode(theme.palette) === "dark"
                ? darken(color, 0.5)
                : lighten(color, 0.5);

        return {
            box: {
                display: "flex",
                flexDirection: "column",
                "justify-content": "center",
                alignItems: "center",
                //            'backgroundColor': 'white',
                /*        'border': '5px solid green',*/
                height: "70vh",
                width: "80vw",
                backgroundColor: "transparent",
            },
            boxPrancheta: {
                height: "70vh",
                width: "80vw",
                backgroundColor: "white",
                flexDirection: "row",

                alignItems: "center",
                justifyContent: "center",
                position: "relative",
            },
            boxToolbar: {
                display: "flex",
                justifyContent: "center",
            },
            boxDataGrid: {
                "& .header_grid": {
                    backgroundColor: "#2471A3",
                    color: "white",
                },
                /*        'display': 'flex',*/
                width: "80vw",
                height: "70vh",
                /*        'flexFlow': '1',
                    'align-content': 'center',
                    'alignItems': 'center',*/
                /*        'border': '5px solid blue',*/
                //            'backgroundColor': 'white',
                "& .super-app-theme--Expirado": {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    "&:hover": {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
                "& .super-app-theme--Duplicado": {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    "&:hover": {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
                "& .super-app-theme--Não-Encontrado": {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    "&:hover": {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
                "& .super-app-theme--Disponível": {
                    backgroundColor: getBackgroundColor(theme.palette.success.main),
                    "&:hover": {
                        backgroundColor: getHoverBackgroundColor(
                            theme.palette.success.main
                        ),
                    },
                },
                "& .super-app-theme--Pendente-Analise": {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    "&:hover": {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
                "& .super-app-theme--Pendente-Reanalise": {
                    backgroundColor: getBackgroundColor(theme.palette.error.main),
                    "&:hover": {
                        backgroundColor: getHoverBackgroundColor(theme.palette.error.main),
                    },
                },
            },
            side_content: {
                /*        'background-color': '#cce0ff',*/
                /*        'border': 'solid 1px #0052cc',*/
                display: "grid",
                overflow: "auto",
            },
            nome: {
                width: "400px",
            },
            header_grid: {
                backgroundColor: "black",
                color: "white",
            },
            input_data: {
                display: "flex",
                flexDirection: "column",
            },
            form: {
                width: "100%", // Fix IE 11 issue.
                marginTop: theme.spacing(1),
            },
            submit: {
                margin: theme.spacing(3, 0, 2),
            },
            input: {
                display: "none",
            },
            ptBR,
        };
    },
    { defaultTheme }
);
